<footer class="fc-footer">
  <div class="fc-footer-inner container">
    <div class="fc-footer-grid">
      <!-- COLUNA 1: MARCA & REDES -->
      <div class="fc-footer-brand">
        <a [routerLink]="['/']" class="fc-footer-logo" aria-label="FundCube - Página inicial">
          <img src="images/logo-branco.png" alt="FundCube" class="fc-footer-logo-img" />
        </a>

        <p class="fc-footer-desc">
          A maior plataforma de crowdfunding de Angola. Conectamos criadores e sonhadores angolanos com apoiadores de
          todo o mundo.
        </p>

        <div class="fc-footer-socials">
          <a href="https://www.facebook.com/profile.php?id=61559049565465" target="_blank" rel="noopener noreferrer"
            class="fc-social-btn" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="https://www.instagram.com/fundcube_ao/" target="_blank" rel="noopener noreferrer"
            class="fc-social-btn" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="https://www.linkedin.com/company/fundcube-ao/posts/" target="_blank" rel="noopener noreferrer"
            class="fc-social-btn" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
          <a href="https://www.youtube.com/@FundCubeAngola" target="_blank" rel="noopener noreferrer"
            class="fc-social-btn" aria-label="YouTube">
            <i class="fab fa-youtube"></i>
          </a>
        </div>
      </div>

      <!-- COLUNA 2: PLATAFORMA -->
      <div class="fc-footer-col">
        <h4 class="fc-footer-title">Plataforma</h4>
        <ul class="fc-footer-links">
          <li><a [routerLink]="['/campanhas']">Explorar Campanhas</a></li>
          <li><a [routerLink]="['/criar-campanha']">Criar Campanha</a></li>
          <li><a [routerLink]="['/']" fragment="como-funciona">Como Funciona</a></li>
          <li><a [routerLink]="['/perguntas-frequentes']">Perguntas Frequentes</a></li>
          <li><a [routerLink]="['/sobre-nos']">Sobre Nós</a></li>
        </ul>
      </div>

      <!-- COLUNA 3: PROGRAMAS & INSTITUCIONAL -->
      <div class="fc-footer-col">
        <h4 class="fc-footer-title">Institucional</h4>
        <ul class="fc-footer-links">
          <li><a [routerLink]="['/sobre-nos']">Quem Somos</a></li>
          <li><a [routerLink]="['/sobre-nos']" fragment="valores">Missão e Valores</a></li>
          <li><a [routerLink]="['/politica-privacidade']">Política de Privacidade</a></li>
          <li><a [routerLink]="['/termos-condicoes']">Termos e Condições</a></li>
          <li><a [routerLink]="['/termos-condicoes']" fragment="seccao-10">Comissões e Taxas</a></li>
          <li><a [routerLink]="['/sobre-nos']" fragment="equipa">A Nossa Equipa</a></li>
        </ul>
      </div>

      <!-- COLUNA 4: CONTACTO & CERTIFICAÇÃO -->
      <div class="fc-footer-col">
        <h4 class="fc-footer-title">Contacto</h4>
        <ul class="fc-footer-contact">
          <li>
            <i class="fas fa-map-marker-alt"></i>
            <span>Rua Rei Katyavala - Edifício Rei Katyavala, 4.º andar, Luanda</span>
          </li>
          <li>
            <i class="fas fa-phone-alt"></i>
            <a href="tel:+244940762031">+244 940 762 031</a>
          </li>
          <li>
            <i class="fas fa-envelope"></i>
            <a href="mailto:geral@fundcube.ao">geral@fundcube.ao</a>
          </li>
        </ul>

        <!-- <div class="fc-footer-cert">
          <span class="fc-cert-label">Certificação & Segurança</span>
          <div class="fc-cert-badges">
            <span class="fc-cert-badge"><i class="fas fa-shield-alt"></i> SSL 256-bit</span>
            <span class="fc-cert-badge"><i class="fas fa-university"></i> BNA</span>
            <span class="fc-cert-badge"><i class="fas fa-check-circle"></i> MINCO</span>
          </div>
        </div> -->
      </div>
    </div>

    <!-- RODAPÉ INFERIOR -->
    <div class="fc-footer-bottom">
      <p class="fc-copy">
        {{ rodape || 'FundCube © ' + anoActual }}. Todos os direitos reservados.
      </p>

      <ul class="fc-footer-legal">
        <li><a [routerLink]="['/termos-condicoes']">Termos de Uso</a></li>
        <li><a [routerLink]="['/politica-privacidade']">Política de Privacidade</a></li>
      </ul>
    </div>
  </div>
</footer>